<template>
  <div v-show="submissionUuid && access" class="comment-wrapper">
    <popper
      :append-to-body="true"
      ref="popper"
      trigger="clickToOpen"
      :options="{
        placement: 'bottom-end',
        modifiers: [{ offset: { offset: '0,0' } }],
      }"
    >
      <div class="popper">
        <div class="popper-content">
          <div v-if="loading" class="spinner-wrapper">
            <double-bounce></double-bounce>
          </div>
          <div class="comment-section md-subhead">Comments</div>
          <div class="comment-section-comments" ref="comments">
            <div
              :id="commentIn.id"
              :key="commentIn.id"
              v-for="commentIn in comments"
            >
              <div v-if="commentIn.id == commentUuid">
                <div class="comment-edit-form">
                  <div class="author">
                    <span
                      v-if="
                        !(
                          (commentIn.user.attributes.field_first_name ===
                            undefined ||
                            commentIn.user.attributes.field_first_name ===
                              null ||
                            commentIn.user.attributes.field_first_name ===
                              '') &&
                          (commentIn.user.attributes.field_last_name ===
                            undefined ||
                            commentIn.user.attributes.field_last_name ===
                              null ||
                            commentIn.user.attributes.field_last_name === '')
                        )
                      "
                      >{{ commentIn.user.attributes.field_first_name }}
                      {{ commentIn.user.attributes.field_last_name }}</span
                    >
                    <span v-else>{{
                      commentIn.user.attributes.display_name
                    }}</span>
                  </div>

                  <md-field>
                    <md-textarea v-model="comment" md-autogrow></md-textarea>
                  </md-field>
                  <div class="comment-section-files">
                    <div
                      :key="file.id"
                      v-for="file in commentIn.files"
                      class="comment-file"
                    >
                      <a target="_blank" :href="file.attributes.uri.url">{{
                        file.attributes.filename
                      }}</a>
                      <md-button
                        @click="deleteSubmittedFile(commentIn, file)"
                        class="md-button md-icon-button"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                  </div>
                  <div class="actions">
                    <md-button class="send" @click="editComment(commentIn)"
                      >Send</md-button
                    >
                    <md-button class="cancel" @click="cancel(commentIn)"
                      >Cancel</md-button
                    >
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="author-section">
                  <div class="author">
                    <span
                      v-if="
                        !(
                          (commentIn.user.attributes.field_first_name ===
                            undefined ||
                            commentIn.user.attributes.field_first_name ===
                              null ||
                            commentIn.user.attributes.field_first_name ===
                              '') &&
                          (commentIn.user.attributes.field_last_name ===
                            undefined ||
                            commentIn.user.attributes.field_last_name ===
                              null ||
                            commentIn.user.attributes.field_last_name === '')
                        )
                      "
                      >{{ commentIn.user.attributes.field_first_name }}
                      {{ commentIn.user.attributes.field_last_name }}</span
                    >
                    <span v-else>{{
                      commentIn.user.attributes.display_name
                    }}</span>
                  </div>
                  <div class="created">
                    {{
                      new Date(commentIn.attributes.created) | moment("from")
                    }}
                  </div>
                  <div v-if="commentIn.canDelete" class="more">
                    <popper
                      ref="comment-menu"
                      trigger="clickToToggle"
                      :options="{
                        placement: 'bottom-end',
                        modifiers: [{ offset: { offset: '0,0' } }],
                      }"
                    >
                      <md-button
                        class="md-button md-icon-button"
                        slot="reference"
                        ref="popperTrigger"
                      >
                        <md-icon>more_vert</md-icon>
                      </md-button>
                      <div class="comment-menu">
                        <div class="popper-content">
                          <a @click="edit(commentIn)">Edit</a>
                          <popper
                            ref="confirm-deleting"
                            trigger="clickToToggle"
                            :options="{
                              placement: 'bottom-end',
                              modifiers: [{ offset: { offset: '0,0' } }],
                            }"
                          >
                            <a slot="reference" ref="popperTrigger">Delete</a>
                            <div class="confirm-deleting">
                              <div class="popper-content">
                                <div class="msg">Delete this comment?</div>
                                <div class="actions">
                                  <md-button
                                    @click="deleteCommentConfirmed(commentIn)"
                                    class="delete md-button"
                                    >Delete</md-button
                                  >
                                  <md-button
                                    @click="deleteCommentCancel"
                                    class="cancel md-button"
                                    >Cancel</md-button
                                  >
                                </div>
                              </div>
                            </div>
                          </popper>
                        </div>
                      </div>
                    </popper>
                  </div>
                </div>
                <div class="comment-text">
                  {{ commentIn.attributes.comment.value }}
                </div>
                <div
                  :key="file.id"
                  v-for="file in commentIn.files"
                  class="comment-file"
                >
                  <a target="_blank" :href="file.attributes.uri.url">{{
                    file.attributes.filename
                  }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="comment-section-add-comment">
            <div class="comment-section-comment-form">
              <div class="comment-input">
                <md-field>
                  <label>Write a comment...</label>
                  <md-textarea
                    @keypress.enter="newComment"
                    @focus="showAddCommentForm = true"
                    v-model="new_comment"
                    md-autogrow
                  ></md-textarea>
                </md-field>
              </div>
              <div class="comment-file">
                <md-button @click="openPicker" class="md-button md-icon-button">
                  <md-icon>attach_file</md-icon>
                </md-button>
                <input
                  @change="selectFile"
                  style="display: none"
                  type="file"
                  ref="inputFile"
                  multiple
                />
              </div>
            </div>
            <div class="comment-section-files">
              <div
                class="status"
                :key="index"
                v-for="(file, index) in attached_files"
              >
                <div class="loading" v-if="file.status == 'loading'">
                  {{ file.name }}
                  <md-progress-spinner
                    class="md-accent"
                    :md-diameter="16"
                    md-mode="indeterminate"
                  ></md-progress-spinner>
                </div>
                <div class="uploaded" v-if="file.status == 'uploaded'">
                  {{ file.name }}
                  <md-button
                    @click="deleteFile(file)"
                    class="md-button md-icon-button"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
                <div class="error" v-if="file.status == 'error'">
                  <b>{{ file.name }}</b>
                  <div>{{ file.error }}</div>
                  <md-button
                    @click="deleteFile(index)"
                    class="md-button md-icon-button"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </div>
            </div>
            <div class="comment-section-buttons" v-show="showAddCommentForm">
              <md-button @click="newComment" class="md-button"
                >Comment</md-button
              >
            </div>
          </div>
        </div>
      </div>
      <md-button
        ref="popper_btn"
        @click="setCommentStatus"
        slot="reference"
        class="comment-button md-icon-button md-raised"
      >
        <md-icon>comment</md-icon>
        <span class="has-new" v-if="hasNew"></span>
      </md-button>
    </popper>
  </div>
</template>


<script>
import { DoubleBounce } from "vue-loading-spinner";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import scrollIntoView from "scroll-into-view";

export default {
  name: "Comment",
  props: ["element-uuid", "submission-uuid", "submission-view-mode"],
  mounted() {
    if (this.submissionUuid != "") {
      this.getComments();
      this.showAddCommentForm = false;
      this.hash = window.location.hash.replace("#", "");
    }
  },
  computed: {
    hasNew() {
      let comments = this.comments.filter((comment) => {
        return !comment.attributes.comment_status;
      });
      return comments.length != 0;
    },
    access() {
      let isAllow = false;
      if (
        this.comments.length &&
        window.drupalSettings.user.role == "learner_reviewer"
      ) {
        if (this.submissionViewMode) {
          return true;
        }
        let nuuid = Object.keys(window.drupalSettings.form_builder)[0];
        let submission =
          window.drupalSettings.form_builder[nuuid].submissions[
            this.submissionUuid
          ];
        if (
          submission.status == 1 ||
          submission.status == this.$status.ACTIVITY_REVIEW_NEEDED ||
          submission.status == this.$status.ACTIVITY_NEEDS_WORK ||
          submission.status == this.$status.ACTIVITY_COMPLETED
        ) {
          return true;
        }
      }
      if (
        (window.drupalSettings.user.role == "coach" &&
          !window.drupalSettings.hasOwnProperty("observation_uuid")) ||
        (window.drupalSettings.user.role == "administrator" &&
          !window.drupalSettings.hasOwnProperty("observation_uuid"))
      ) {
        return true;
      }
      Object.values(window.drupalSettings.user.all_available_roles).forEach((item) => {
        if (item == 'coach') {
          let learners = window.drupalSettings.user.learners;
          learners.forEach((learner) => {
            if (learner.uuid == window.drupalSettings.activitySubmissionUserUuid) {
              isAllow = true;
            }
          })
        }
      });
      return isAllow;
    },
  },
  data() {
    return {
      hash: null,
      toggleComments: false,
      comment: "",
      new_comment: "",
      comments: [],
      loading: false,
      commentUuid: null,
      attached_files: [],
      showAddCommentForm: true,
      entity_type:
        window.drupalSettings.entityType ||
        this.getSubmission().entity_type ||
        null,
      entity_id:
        window.drupalSettings.entityId ||
        this.getSubmission().entity_id ||
        null,
    };
  },
  methods: {
    getSubmission() {
      let nuuid = Object.keys(window.drupalSettings.form_builder)[0];
      let submission =
        window.drupalSettings.form_builder[nuuid].submissions[
          this.submissionUuid
        ];
      return submission ? submission : {};
    },
    log(msg) {
      console.log(msg);
    },
    setCommentStatus() {
      this.comments.forEach((comment) => {
        if (comment.attributes.comment_status) {
          return;
        }
        let id = comment.attributes.drupal_internal__id;
        this.getToken().then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          return fetch("/ajax/catch_comment/" + id, {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          });
        });
      });
    },
    deleteSubmittedFile(comment, deletedFile) {
      event.preventDefault();
      event.stopPropagation();
      this.loading = true;
      comment.files.splice(comment.files.indexOf(deletedFile), 1);
      return this.getToken().then((token) => {
        let files = comment.files.filter((file) => {
          return file.status == "uploaded";
        });
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = "PATCH";

        let relationships = null;
        relationships = {
          relationships: {
            attached_file: {
              data: files.map((file) => {
                return {
                  type: "file--file",
                  id: file.uuid,
                };
              }),
            },
          },
        };

        fetch("/jsonapi/catch_comment/catch_comment/" + comment.id, {
          credentials: "include",
          method: method,
          headers: fetch_headers,
          body: JSON.stringify({
            data: {
              id: comment.id,
              type: "catch_comment--catch_comment",
              attributes: {
                element_uuid: this.elementUuid,
                submission_uuid: this.submissionUuid,
                comment: comment.comment,
              },
              ...relationships,
            },
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then(() => {
            this.comment = "";
            this.new_comment = "";
            this.commentUuid = null;
            this.attached_files = [];
            return this.getComments();
          })
          .then(() => {
            this.loading = false;
            setTimeout(() => {
              this.$refs["comments"].scrollTop = this.$refs[
                "comments"
              ].scrollHeight;
            }, 200);
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    deleteFile(file) {
      event.preventDefault();
      event.stopPropagation();
      this.attached_files.splice(this.attached_files.indexOf(file), 1);
    },
    selectFile(file) {
      let files = file.target.files;
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        this.attached_files.push({
          status: "loading",
          name: file.name,
          uuid: null,
        });
        let key = this.attached_files.length - 1;
        this.readFile(file)
          .then((buffer) => {
            return this.uploadFile(buffer, file.name);
          })
          .then((data) => {
            this.attached_files[key].status = "uploaded";
            this.attached_files[key].uuid = data.uuid;
            if (this.$refs["popper"] && this.$refs["popper"].popperJS) {
              this.$refs["popper"].popperJS.update();
            }
          })
          .catch((error) => {
            this.attached_files[key].status = "error";
            if (error.message.match(/file\svalidation\sfailed/)) {
              error.message = error.message.split(/\n/)[1]
                ? error.message.split(/\n/)[1]
                : error.message;
            }
            this.attached_files[key].error = error.message;
            this.attached_files[key].uuid = null;
            if (this.$refs["popper"] && this.$refs["popper"].popperJS) {
              this.$refs["popper"].popperJS.update();
            }
          });
      }
    },
    openPicker() {
      this.$refs.inputFile.value = "";
      this.$refs.inputFile.click();
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.addEventListener("loadend", function (e) {
          // reader.result contains the contents of blob as a typed array
          if (!e.target.result) {
            reject();
          }
          resolve(e.target.result);
        });
        if (file != "") {
          reader.readAsArrayBuffer(file);
        } else {
          reject();
        }
      });
    },
    uploadFile(buffer, name) {
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/octet-stream");
        fetch_headers.append("X-CSRF-Token", token);
        fetch_headers.append(
          "Content-Disposition",
          'file; filename="' + name + '"'
        );
        return fetch("/jsonapi/catch_comment/catch_comment/attached_file", {
          credentials: "include",
          method: "POST",
          headers: fetch_headers,
          body: buffer,
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (json.errors && json.errors.length) {
              throw new Error(json.errors[0].detail);
            }
            this.uuid = json.data.id;
            this.uri = json.data.attributes.uri.url;
            this.name = json.data.attributes.filename;
            this.uploaded = true;
            return {
              uri: this.uri,
              name: this.name,
              uuid: this.uuid,
            };
          });
      });
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          return text;
        });
    },
    toggle() {
      this.toggleComments = !this.toggleComments;
    },
    getComments() {
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch(
          "/jsonapi/catch_comment/catch_comment?sort=created&include=user,attached_file&filter[element_uuid]=" +
            this.elementUuid +
            "&filter[submission_uuid]=" +
            this.submissionUuid,
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            let included = {};
            if (json.included) {
              json.included.forEach((data) => {
                included[data.id] = data;
              });
            }
            this.comments = json.data.map((comment) => {
              if (this.hash == comment.id) {
                this.$refs["popper_btn"].$el.click();
                setTimeout(() => {
                  scrollIntoView(window.document.getElementById(comment.id));
                  window.location.hash = "";
                }, 300);
              }
              let userUuid = comment.relationships.user.data.id;
              let files =
                comment.relationships.attached_file &&
                comment.relationships.attached_file.data
                  ? comment.relationships.attached_file.data
                  : null;
              let user = included[userUuid];

              comment.files = [];
              if (files) {
                files.map((file) => {
                  comment.files.push(included[file.id]);
                });
              }
              comment.user = user;

              comment.canDelete =
                window.drupalSettings.user.uid ==
                  user.attributes.drupal_internal__uid ||
                window.drupalSettings.user.uid == 1 ||
                (userUuid == window.drupalSettings.user.uuid &&
                  comment.attributes.parent_id == 0);

              return comment;
            });

            this.showAddCommentForm = false;
            if (this.$refs["popper"] && this.$refs["popper"].popperJS) {
              this.$refs["popper"].popperJS.update();
            }
            return this.comments;
          });
      });
    },
    editComment() {
      return this.setComment();
    },
    cancel() {
      event.preventDefault();
      event.stopPropagation();
      this.commentUuid = null;
      this.comment = "";
    },
    newComment() {
      this.commentUuid = null;
      this.comment = this.new_comment;

      return this.setComment();
    },
    edit(comment) {
      event.preventDefault();
      event.stopPropagation();
      this.commentUuid = comment.id;
      this.comment = comment.attributes.comment.value;
    },
    closeCommentMenu() {
      this.$refs["comment-menu"].forEach((popper) => {
        popper.doClose();
      });
    },
    deleteCommentConfirmed(comment) {
      this.$refs["confirm-deleting"].forEach((popper) => {
        popper.doClose();
      });
      this.deleteComment(comment);
    },
    deleteCommentCancel(comment) {
      /*this.$refs['confirm-deleting'].forEach(popper => {
          popper.doClose();
        });*/
      this.closeCommentMenu();
    },
    deleteComment(comment) {
      this.loading = true;
      return this.getToken()
        .then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          let method = "DELETE";
          return fetch("/jsonapi/catch_comment/catch_comment/" + comment.id, {
            credentials: "include",
            method: method,
            headers: fetch_headers,
          });
        })
        .then(() => {
          this.comment = "";
          this.commentUuid = null;
          return this.getComments();
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    setComment() {
      this.loading = true;
      return this.getToken().then((token) => {
        let files = this.attached_files.filter((file) => {
          return file.status == "uploaded";
        });

        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = "POST";
        if (this.commentUuid) {
          method = "PATCH";
        }
        let relationships = null;
        if (files.length) {
          relationships = {
            relationships: {
              attached_file: {
                data: files.map((file) => {
                  return {
                    type: "file--file",
                    id: file.uuid,
                  };
                }),
              },
            },
          };
        }
        fetch(
          "/jsonapi/catch_comment/catch_comment" +
            (this.commentUuid ? "/" + this.commentUuid : ""),
          {
            credentials: "include",
            method: method,
            headers: fetch_headers,
            body: JSON.stringify({
              data: {
                id: this.commentUuid,
                type: "catch_comment--catch_comment",
                attributes: {
                  element_uuid: this.elementUuid,
                  submission_uuid: this.submissionUuid,
                  comment: this.comment,
                  entity_type: this.entity_type,
                  entity_id: this.entity_id,
                },
                ...relationships,
              },
            }),
          }
        )
          .then((response) => {
            return response.json();
          })
          .then(() => {
            this.comment = "";
            this.new_comment = "";
            this.commentUuid = null;
            this.attached_files = [];
            return this.getComments();
          })
          .then(() => {
            this.loading = false;
            setTimeout(() => {
              this.$refs["comments"].scrollTop = this.$refs[
                "comments"
              ].scrollHeight;
            }, 200);
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
  components: {
    DoubleBounce,
    Popper,
  },
};
</script>

<style lang="scss" scoped>
.md-field.md-theme-default:before {
  background-color: $blue-active;
  height: 1px;
}

.comment-wrapper {
  float: right;
  .comment-actions {
    display: flex;
    justify-content: flex-end;

    .md-focused {
      &:before {
        background-color: $blue-active;
        height: 1px;
      }
    }
  }
}

.comment-edit-form {
  justify-content: flex-end;
  .author {
    width: 205px;
    overflow: hidden;
    margin-right: 10px;
    text-align: left;
    color: $blue-active;
    font-size: 16px;
  }
  .md-field {
    //margin: 4px 0 16px;
    margin: -15px 0 16px;
  }
  .actions {
    display: flex;
  }
}

.spinner-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 101;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 20px;
}
</style>


<style lang="scss">
.popper {
  min-width: 400px;
  max-width: 400px;
  @media all and (max-width: $breakpoint-medium) {
    min-width: unset;
    max-width: 90%;
    z-index: 4 !important;
  }
  &.toolbar {
    min-width: 100px;
  }
  background-color: transparent;
  text-align: left;
  padding: 0px;
  border-radius: 0px;
  border: none;
  box-shadow: none;
  .popper-content {
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 3px 3px 20px 2px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
}

.toolbar.popper[x-placement^="bottom"] .popper__arrow {
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #fff transparent;
  top: -9px;
  transform: translateX(0px);
  text-align: left;
}

.popper[x-placement^="bottom"] .popper__arrow {
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent $blue-active transparent;
  top: -9px;
  transform: translateX(-5px);
  text-align: left;
  @media all and (max-width: $breakpoint-medium) {
    transform: translateX(0px);
    top: -7px;
  }
}

.comment-section {
  background-color: $blue-active;
  padding: 20px;
  color: rgb(255, 255, 255);
  font-size: 16px;
  font-weight: bold;
}

.comment-section-comments {
  background-color: $grey-light;
  font-family: $font-source-sans-pro;
  > div {
    border-radius: 8px;
    padding: 0px 10px;
    margin: 10px 10px;
    padding-bottom: 0px;
    &:last-child {
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
    // &:nth-child(even) {
    //   background: rgb(245, 245, 245);
    // }
  }
  overflow: auto;
  max-height: 200px;
}

.comment-section-comment-form {
  background-color: #fff;
  padding: 0 20px;
  display: flex;
  flex: 1;
  .comment-input {
    width: 100%;
    label {
      color: rgb(180, 180, 181);
      font-weight: normal;
      font-size: 14px;
      margin-top: -5px;
    }
    .md-field {
      margin: 4px 0 10px;
      &:before {
        background-color: $blue-active;
        height: 1px;
      }
      &:after {
        background-color: transparent;
      }
    }
  }

  .comment-file {
    padding-top: 5px;
    width: 50px;
    i {
      font-weight: normal;
      color: #b7b7b8 !important;
      transform: rotate(45deg);
    }
  }
  .md-focused,
  .md-has-value {
    label {
      display: none;
    }
  }
}

.comment-file {
  margin-top: 5px;
  a {
    color: $blue-active !important;
    font-weight: normal;
  }
}

.confirm-deleting {
  .msg {
    padding: 15px 10px 5px;
  }
  .actions {
    display: flex;
  }
  .md-button.delete {
    background: $blue-dark;
    color: #ffffff !important;
    display: flex;
    align-items: center;
  }
  .md-button.cancel {
    color: $blue-dark;
    &:hover:before {
      background: unset;
    }
  }
}

.comment-edit-form {
  .md-button.send {
    background: $blue-dark;
    color: #ffffff !important;
    display: flex;
    align-items: center;
  }
  .md-button.cancel {
    color: $blue-dark;
    &:hover:before {
      background: unset;
    }
  }
}

.comment-section-buttons {
  padding-bottom: 10px;
  padding-left: 10px;
  .md-button {
    background: $blue-dark;
    color: #ffffff !important;
    display: flex;
    align-items: center;
  }
}

.comment-text {
  color: rgb(60, 60, 60);
  font-size: 16px;
  font-weight: normal;
}

.author-section {
  display: flex;
  justify-content: space-between;
  font-family: $font-source-sans-pro;

  .author {
    display: flex;
    align-items: center;
    width: 205px;
    overflow: hidden;
    margin-right: 10px;
    text-align: left;
    color: $blue-active;
    font-size: 16px;
    font-weight: normal;
    span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .created {
    display: flex;
    align-items: center;
    text-align: right;
    color: rgb(124, 124, 124);
    font-size: 16px;
    font-weight: normal;
    width: 110px;
  }
  .more {
    .md-icon-button {
      min-width: 24px;
      width: 24px;
      .md-ripple {
        padding: 0px !important;
      }
    }
  }
}

.comment-menu {
  z-index: 9;
  .popper__arrow {
    display: none;
  }
  .popper-content {
    width: 200px;
    box-shadow: 0px 0px 4px 0px rgba(60, 60, 60, 0.5);
    a {
      display: block;
      font-size: 14px;
      font-weight: normal;
      line-height: 16px;
      color: rgb(60, 60, 60) !important;
      padding: 10px 20px;

      &:hover {
        background: $grey-light;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}

.comment-section-files {
  overflow: auto;
  max-height: 200px;
  padding: 0px 10px;
  .md-icon-button {
    width: 24px;
    min-width: 24px;
    height: 24px;
    &.md-theme-default .md-ripple {
      padding: 0px 0px;
      .md-icon {
        width: 24px;
        min-width: 16px;
        height: 16px;
        font-size: 16px !important;
      }
    }
  }
  .uploaded {
    color: $blue-active !important;
  }
  .status {
    > div {
      padding: 10px;
    }
    .error {
      background-color: #e6d8e6;
      color: #e73950;
    }
  }
}

.has-new {
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #f64536;
  top: -8px;
  right: -8px;
  border-radius: 50%;
  border: 1px solid #fff;
}

.md-button.comment-button.md-icon-button.md-raised {
  overflow: visible;
  background-color: $blue-active !important;
  color: #fff !important;
  &::before {
    border-radius: 0;
  }
  .md-ripple {
    border-radius: 0;
  }
  .md-icon {
    color: #fff !important;
  }
}
</style>
